
$( document ).ready( function () {
  
 
  
  if ( $(window).width() <= 1024) { 
    $( ".img-collections" ).remove();
  }  
  // ===== Scroll to Top ==== 
  $(window).scroll(function() {
      if ($(this).scrollTop() >= 50) {        // If page is scrolled more than 50px
          $('#return-to-top').fadeIn(200);    // Fade in the arrow
      } else {
          $('#return-to-top').fadeOut(200);   // Else fade out the arrow
      }
  });
  $('#return-to-top').click(function() {      // When arrow is clicked
      $('body,html').animate({
          scrollTop : 0                       // Scroll to top of body
      }, 500);
  });

  $( '.overlay-div .close-btn' ).click( function (){
    $( 'body' ).removeClass( 'search-reveal' );
  } );
  $('#search-abc').click(function(){
    $('body').addClass('search-reveal');   
  });
  
  $( '.close-filter a' ).click( function (){
    $( '.filter-category' ).removeClass( 'filter-box' );
  } );
  $('.filters-toolbar-box label').click(function(){
    $('.filter-category').addClass('filter-box');   
  });
  
  $(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 0.1) {
       $("body").addClass("sticky");
       $(".blank-div").css("height", $('.main-menu').outerHeight())
    } else {
       $("body").removeClass("sticky");
       $(".blank-div").css("height", "auto")
    }
});
  $(".tab-button-1").click(function() {
    $('html, body').animate({
        scrollTop: $("#myDiv-1").offset().top
    }, 2000);
  });
  $(".tab-button-2").click(function() {
    $('html, body').animate({
        scrollTop: $("#myDiv-2").offset().top
    }, 2000);
  });
  $(".tab-button-3").click(function() {
    $('html, body').animate({
        scrollTop: $("#myDiv-3").offset().top
    }, 2000);
  });
  $(".tab-button-4").click(function() {
    $('html, body').animate({
        scrollTop: $("#myDiv-4").offset().top
    }, 2000);
  });
  $(".tab-button-5").click(function() {
    $('html, body').animate({
        scrollTop: $("#myDiv-5").offset().top
    }, 2000);
  });
  
 $(".slide-next").on('click', function(event) {
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;
      $('html, body').animate({
        scrollTop: $(hash).offset().top - $("desktop-menu").outerHeight()
		}, 800, function(){
			$('html, body').animate({
        scrollTop: $(hash).offset().top - $("desktop-menu").outerHeight()
		}, 200)
      });
    }
  });
  
  var headerHeight=$('.sticky-header').outerHeight(true);
  
  $('.section-navigation ul li a').click(function(e){
	e.preventDefault();
    $('.term-condition-accordian .active').removeClass('active');
    $('.term-condition-accordian .accordion-content').hide();
    
    
	var valuefor;
    
	var someVal=$(this).attr('id');
	console.log(someVal);
    
    
    $('li#'+someVal +' a').addClass('active');
    $('li#'+someVal +' .accordion-content').show();
    
    //$("#accordion").accordion("option", "active", $("#panel2").index("#accordion div"));
    
	/*var href=this.href.substr(this.href.lastIndexOf('/') + 1);
    
    $('.term-condition-accordian ul li .accordion-content').each(function(){	
        valuefor=$(this).attr('id');
        if(valuefor == someVal){
            $(this).parent().siblings().children('.accordion-content').hide();	
            $(this).show();

        }
    });*/

    		$('html,body').animate({
            	scrollTop:$(this).offset().top
            },1000)
	});
  
  
  

	$('.sbOptions li a').click(function(e){	
		e.preventDefault();
  		var location="https://clae-dev.myshopify.com";
		var href=$(this).attr('href');
		window.location= location + href;
		return false;
	});
});




